import { Component, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { ToolbarModule } from 'primeng/toolbar';
import { AUTH_BUTTON_LABELS } from '../../auth-button-labels';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [MenubarModule, ButtonModule, ToolbarModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class HeaderComponent {
  readonly authButtonLabels = AUTH_BUTTON_LABELS;
  private readonly destroy$ = new Subject<void>();
  items = [
    { label: 'Home', icon: 'pi pi-home', routerLink: '/' },
    { label: 'Users', icon: 'pi pi-users', routerLink: '/users' },
    { label: 'Reports', icon: 'pi pi-chart-bar', routerLink: '/reports' },
    { label: 'Settings', icon: 'pi pi-cog', routerLink: '/settings' },
  ];
  @Input() isUserLoggedIn = false;
  isAuthActionInProgress = false;
  isAuthRoute = false;
  constructor(
    private msalService: MsalService,
    private router: Router,
  ) { }
  async ngOnInit() {
    await this.msalService.instance.initialize();

    this.updateRouteState(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        this.updateRouteState(event.urlAfterRedirects);
      });

    const currentAccount = this.msalService.instance.getAllAccounts();
    if (currentAccount.length > 0) {
      this.isUserLoggedIn = true
      this.router.navigate(['/']);
    }

  }
  // async login() {
  //   if (this.isAuthActionInProgress) {
  //     return;
  //   }

  //   this.isAuthActionInProgress = true;
  //   sessionStorage.clear();

  //   try {
  //     await this.msalService.loginRedirect();
  //   } catch (error) {
  //     this.isAuthActionInProgress = false;
  //     console.error('MSAL header login redirect failed', error);
  //   }

  // }
  async logout() {
    if (this.isAuthActionInProgress) {
      return;
    }

    this.isAuthActionInProgress = true;
    this.isUserLoggedIn = false;

    try {
      await this.msalService.logoutRedirect();
    } catch (error) {
      this.isAuthActionInProgress = false;
      console.error('MSAL header logout redirect failed', error);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateRouteState(url: string): void {
    const normalizedUrl = url.split('?')[0].toLowerCase();
    this.isAuthRoute = normalizedUrl === '/auth' || normalizedUrl === '/auth/';
  }
}
